import { memoize } from 'underscore';

// By default, _.memoize will only check the first parameter to determine if cache is hit
// Pass a customized hash function so that it won't use cached version when any of the paramters
// are updated
export const memoizeWithAllArgsHashed = fn => memoize(fn, (...args) => {
  if (args) {
    return args.join(',');
  }

  return `${args}`;
});
